import { render } from "./Alerts.vue?vue&type=template&id=dd5ffc6a&scoped=true"
import script from "./Alerts.vue?vue&type=script&lang=ts"
export * from "./Alerts.vue?vue&type=script&lang=ts"

import "./Alerts.vue?vue&type=style&index=0&id=dd5ffc6a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dd5ffc6a"

export default script